import { useCallback, useEffect } from "react"
import { isEmpty, postSubmit } from "@ui-seeker/utils"
import { useSignal } from "@preact/signals-react"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"
import { useToast } from "@hooks"
import { setReportData } from "Pages/ReportsAlerts/Reports/@signals"
import { REPORT_STATUS } from "@constants"

export default function usePerformReport(idReport, name) {
	const { searchUrl, reportType } = useReportBackendApiPath()
	const isLoading = useSignal(false)
	const { showToast } = useToast()

	const setIsLoading = () => isLoading.value = true

	const onPerform = useCallback(() => showToast.confirm(`Are you sure want to perform the report titled ${name}?`, {
		title: 'Perform report?',
		tone: 'warning',
		icon: 'gears',
		submitText: 'Perform',
		onSubmit: () => {
			isLoading.value = true
			postSubmit(`${searchUrl}/reports/execute`, {
				idReport: idReport,
				isManualExecution: true,
				reportType: reportType
			}).then(res => {
				if (!isEmpty(res)) {
					setReportData({
						idReport: idReport,
						idLastExecution: res[idReport],
						statusLastExecution: REPORT_STATUS.RUNNING,
					})
				} else {
					showToast.warning("Non valid reports were given, aborting task")
				}
				isLoading.value = false
			}).catch(() => {
				showToast.error('Report execution failed, please try again.')
				setReportData({ idReport: idReport, statusLastExecution: REPORT_STATUS.READY })
				isLoading.value = false
			})
		},
		onCancel: () => isLoading.value = false,
	}), [idReport])

	useEffect(() => {
		if (isLoading.value) onPerform()
	}, [isLoading.value])

	return {
		setIsLoading,
		isLoading: isLoading.value
	}

}